import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { FileDown, Search, CheckCircle, Clock, X } from 'lucide-react';

const S = {
  heading: { fontSize:22, fontWeight:700, color:'#f6c90e', marginBottom:4 },
  sub: { fontSize:13, color:'#475569', marginBottom:24 },
  toolbar: { display:'flex', gap:12, marginBottom:16, flexWrap:'wrap' },
  searchBox: { display:'flex', alignItems:'center', gap:8, background:'#0e1420', border:'1px solid #1a2035', borderRadius:8, padding:'8px 12px', flex:1, maxWidth:300 },
  searchInput: { background:'none', border:'none', color:'#e2e8f0', fontSize:13, outline:'none', flex:1 },
  th: { padding:'10px 14px', textAlign:'left', fontSize:11, color:'#475569', textTransform:'uppercase', letterSpacing:1, borderBottom:'1px solid #1a2035' },
  td: { padding:'12px 14px', fontSize:13, color:'#cbd5e1', borderBottom:'1px solid #0f1117' },
  btn: (c='#f6c90e', disabled=false) => ({
    display:'flex', alignItems:'center', gap:5, padding:'6px 12px', borderRadius:7,
    background: disabled ? '#1a2035' : `${c}22`,
    color: disabled ? '#475569' : c,
    fontSize:12, fontWeight:600,
    cursor: disabled ? 'not-allowed' : 'pointer',
    border:`1px solid ${disabled ? '#2d3748' : c+'44'}`,
    whiteSpace:'nowrap',
  }),
};

const linkStyle = { background:'none', border:'none', color:'#e2e8f0', fontWeight:700, cursor:'pointer', padding:0, fontSize:'inherit', textDecoration:'underline', textDecorationColor:'rgba(226,232,240,0.3)', textUnderlineOffset:2 };

/* ─── Modal: escolher qual kit (entre os candidatos da proposta) vai para o contrato ─── */
function EscolherKitContratoModal({ lead, gerando, onConfirm, onClose }) {
  const fmtBRL = (v) => Number(v).toLocaleString('pt-BR', { style:'currency', currency:'BRL' });
  const candidatos = lead.kits_propostos || [];
  const [selectedKitId, setSelectedKitId] = useState(
    lead.kit_id ? String(lead.kit_id) : (candidatos.length === 1 ? String(candidatos[0].kit_id) : '')
  );

  const overlay = { position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', zIndex:400, display:'flex', alignItems:'center', justifyContent:'center' };
  const box     = { background:'#0e1420', border:'1px solid #1a2035', borderRadius:14, padding:24, width:480, maxWidth:'95vw', maxHeight:'88vh', display:'flex', flexDirection:'column' };

  return (
    <div style={overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={box}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
          <div>
            <div style={{ fontSize:16, fontWeight:700, color:'#f6c90e' }}>Confirme o Kit</div>
            <div style={{ fontSize:12, color:'#475569', marginTop:2 }}>Cliente: {lead.cliente}</div>
          </div>
          <button onClick={onClose} style={{ background:'none', border:'none', color:'#64748b', cursor:'pointer' }}><X size={18}/></button>
        </div>

        {candidatos.length === 0 ? (
          <div style={{ fontSize:13, color:'#f87171', marginBottom:16 }}>
            Nenhum kit foi proposto para esta venda. Gere a proposta antes de gerar o contrato.
          </div>
        ) : (
          <div style={{ flex:1, overflowY:'auto', marginBottom:16, display:'flex', flexDirection:'column', gap:8 }}>
            <div style={{ fontSize:13, color:'#94a3b8', marginBottom:4 }}>
              Selecione qual kit, entre as opções propostas, vai para o contrato:
            </div>
            {candidatos.map((c, i) => {
              const sel = String(c.kit_id) === selectedKitId;
              return (
                <div
                  key={c.kit_id || i}
                  onClick={() => setSelectedKitId(String(c.kit_id))}
                  style={{ cursor:'pointer', background: sel ? 'rgba(246,201,14,0.08)' : '#080c14', border: sel ? '1px solid #f6c90e' : '1px solid #1a2035', borderRadius:10, padding:'12px 14px', display:'flex', alignItems:'center', gap:10 }}
                >
                  <div style={{ width:16, height:16, borderRadius:'50%', border:`2px solid ${sel ? '#f6c90e' : '#2d3748'}`, background: sel ? '#f6c90e' : 'transparent', flexShrink:0 }}/>
                  <div>
                    <div style={{ fontSize:13, fontWeight:700, color:'#e2e8f0' }}>
                      Opção {c.ordem || i + 1} · {c.kit_marca ? `${c.kit_marca} ` : ''}{c.kit_equipamento || '—'}
                    </div>
                    <div style={{ fontSize:12, color:'#64748b', marginTop:2 }}>
                      {c.kit_geracao ? `${c.kit_geracao} kWh/mês · ` : ''}
                      {c.kit_qtd_inversores != null ? `${c.kit_qtd_inversores} inversor(es) · ` : ''}
                      {c.valor_proposto != null ? <span style={{ color:'#4ade80', fontWeight:600 }}>{fmtBRL(c.valor_proposto)}</span> : '—'}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div style={{ display:'flex', justifyContent:'flex-end', gap:10 }}>
          <button onClick={onClose} style={{ background:'transparent', color:'#64748b', border:'1px solid #1a2035', borderRadius:8, padding:'8px 16px', fontSize:13, cursor:'pointer' }}>
            Cancelar
          </button>
          <button
            disabled={!selectedKitId || gerando}
            onClick={() => onConfirm(selectedKitId)}
            style={{ background: (!selectedKitId || gerando) ? '#1a2035' : '#f6c90e', color: (!selectedKitId || gerando) ? '#475569' : '#080c14', border:'none', borderRadius:8, padding:'8px 18px', fontSize:13, fontWeight:700, cursor: (!selectedKitId || gerando) ? 'not-allowed' : 'pointer' }}
          >
            {gerando ? 'Gerando...' : 'Gerar Contrato'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function GeradorContrato() {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState('');
  const [gerandoId, setGerandoId] = useState(null);
  const [view, setView] = useState('disponivel');
  const [kitContratoModal, setKitContratoModal] = useState(null); // lead objeto
  const [erro, setErro] = useState('');

  const fetchLeads = (v) => {
    setErro('');
    api.get(`/documentos/leads-contrato/?view=${v || 'disponivel'}`).then(r => setLeads(r.data)).catch(() => setErro('Erro ao carregar dados. Tente atualizar a página.'));
  };
  useEffect(() => { fetchLeads('disponivel'); }, []);

  const switchView = (v) => { setView(v); setSearch(''); fetchLeads(v); };

  const filtered = leads.filter(l =>
    l.cliente?.toLowerCase().includes(search.toLowerCase()) ||
    l.cidade?.toLowerCase().includes(search.toLowerCase())
  );

  const gerar = async (leadId, kitId) => {
    setGerandoId(leadId);
    try {
      const body = kitId ? { kit_id: kitId } : {};
      const resp = await api.post(`/documentos/gerar-contrato/${leadId}/`, body, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url; a.download = `contrato_${leadId}.pdf`; a.click();
      window.URL.revokeObjectURL(url);
      fetchLeads(view);
    } catch (e) {
      alert('Erro ao gerar contrato: ' + (e.response?.data?.error || e.message || 'tente novamente'));
    } finally {
      setGerandoId(null);
    }
  };

  const handleGerarClick = (lead) => {
    setKitContratoModal(lead);
  };

  return (
    <div>
      <div style={S.heading}>Gerador de Contrato</div>
      <div style={S.sub}>Gere contratos de prestação de serviços em PDF para seus clientes</div>
      {erro && (
        <div style={{ background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)', borderRadius:8, padding:'10px 14px', color:'#f87171', fontSize:13, marginBottom:14 }}>{erro}</div>
      )}
      <div style={S.toolbar}>
        <div style={S.searchBox}>
          <Search size={14} color="#475569" />
          <input
            style={S.searchInput}
            placeholder="Buscar cliente..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <div style={{ display:'flex', gap:6 }}>
          {[
            { v:'disponivel', l:'Disponível' },
            { v:'fechadas',   l:'Vendas Fechadas' },
          ].map(opt => (
            <button
              key={opt.v}
              onClick={() => switchView(opt.v)}
              style={{
                padding:'8px 16px', borderRadius:8, fontSize:13, fontWeight:600,
                cursor:'pointer', border:'1px solid',
                background: view === opt.v ? 'rgba(246,201,14,0.15)' : 'transparent',
                color:       view === opt.v ? '#f6c90e' : '#64748b',
                borderColor: view === opt.v ? 'rgba(246,201,14,0.4)' : '#1a2035',
              }}
            >{opt.l}</button>
          ))}
        </div>
      </div>

      <div style={{ background:'#0e1420', border:'1px solid #1a2035', borderRadius:12, overflowX:'auto', overflowY:'auto', maxHeight:400 }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr>
              <th style={S.th}>#</th>
              <th style={S.th}>Cliente</th>
              <th style={S.th}>Cidade</th>
              <th style={S.th}>Vendedor</th>
              <th style={S.th}>Valor da Venda</th>
              <th style={S.th}>{view === 'fechadas' ? 'Data da Venda' : 'Contrato'}</th>
              <th style={S.th}>Ação</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(l => {
              const loading = gerandoId === l.lead_id;
              return (
                <tr
                  key={l.lead_id}
                  onMouseEnter={e => e.currentTarget.style.background = '#111827'}
                  onMouseLeave={e => e.currentTarget.style.background = ''}
                >
                  <td style={S.td}>#{l.lead_id}</td>
                  <td style={S.td}><button style={linkStyle} onClick={() => navigate(`/jornada/${l.cliente_id}`)}>{l.cliente}</button></td>
                  <td style={S.td}>{l.cidade}</td>
                  <td style={S.td}>{l.vendedor}</td>
                  <td style={S.td}>
                    {l.valor_total_venda != null
                      ? <span style={{ color:'#f6c90e', fontWeight:600 }}>
                          R$ {Number(l.valor_total_venda).toLocaleString('pt-BR', { minimumFractionDigits:2 })}
                        </span>
                      : <span style={{ color:'#475569' }}>—</span>
                    }
                  </td>
                  <td style={S.td}>
                    {view === 'fechadas' ? (
                      <span style={{ color:'#4ade80', fontWeight:600, fontSize:13 }}>{l.venda_fechada_em || '—'}</span>
                    ) : l.contrato_gerado ? (
                      <span style={{ display:'flex', alignItems:'center', gap:5, color:'#4ade80', fontSize:12 }}>
                        <CheckCircle size={13} /> Gerado
                      </span>
                    ) : (
                      <span style={{ display:'flex', alignItems:'center', gap:5, color:'#475569', fontSize:12 }}>
                        <Clock size={13} /> Pendente
                      </span>
                    )}
                  </td>
                  <td style={S.td}>
                    <button
                      style={S.btn('#f6c90e', loading)}
                      onClick={() => !loading && handleGerarClick(l)}
                      disabled={loading}
                    >
                      <FileDown size={13} />
                      {loading ? 'Gerando...' : l.contrato_gerado ? 'Regerar Contrato' : 'Gerar Contrato'}
                    </button>
                  </td>
                </tr>
              );
            })}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={7} style={{ ...S.td, textAlign:'center', color:'#475569', padding:32 }}>
                  Nenhum lead encontrado
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {kitContratoModal && (
        <EscolherKitContratoModal
          lead={kitContratoModal}
          gerando={gerandoId === kitContratoModal.lead_id}
          onConfirm={(kitId) => { gerar(kitContratoModal.lead_id, kitId); setKitContratoModal(null); }}
          onClose={() => setKitContratoModal(null)}
        />
      )}
    </div>
  );
}
